// extracted by mini-css-extract-plugin
export default {"process-bar":"coverage-steps-module__process-bar--g_T","processBar":"coverage-steps-module__process-bar--g_T"};